/**
 * Order Ping — lightweight polling checks for notifications.
 *
 * Uses dedicated GET /order-count endpoint (single COUNT query).
 * Also supports low-stock-count check for inventory alerts.
 */
import { http } from "../utils/config";

/**
 * Fetch current new-order count for the given idw.
 * Returns { count: number } or throws on failure.
 */
export async function fetchOrderCount(idw) {
  if (!idw) return { count: 0 };

  const res = await http.get(`/order-count?idw=${idw}`);

  if (res.data?.status === 200 && res.data?.data?.count !== undefined) {
    return { count: res.data.data.count };
  }

  // Fallback: API returned non-200 or unexpected shape
  return { count: 0 };
}

/**
 * Fetch current low-stock product count for the given idw.
 * Returns { count: number }.
 */
export async function fetchLowStockCount(idw) {
  if (!idw) return { count: 0 };

  try {
    const res = await http.post("/inventory/low-stock-count", { idw });
    const count = res.data?.data?.count;
    return { count: typeof count === "number" ? count : 0 };
  } catch {
    return { count: 0 };
  }
}
